import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../redux/axios/axios";
const fetchMembersData = async () => {
  try {
    const response = await axiosInstance.get("/members");
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

const useSupportSpeaks = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["membersData"],
    queryFn: fetchMembersData,
  });
  return { data, isLoading, isError, error };
};

export default useSupportSpeaks;
